import { render, staticRenderFns } from "./comfortZone.vue?vue&type=template&id=08442566"
import script from "./comfortZone.vue?vue&type=script&lang=js"
export * from "./comfortZone.vue?vue&type=script&lang=js"
import style0 from "./comfortZone.vue?vue&type=style&index=0&id=08442566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports